import { useState, useCallback, useRef } from 'react';
import { scraperApi } from '../api/client';

export function useScraper(onComplete) {
  const [scraping, setScraping] = useState(false);
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);
  const pollRef = useRef(null);

  const startScrape = useCallback(async (sources = ['ebay', 'vinted']) => {
    setScraping(true);
    setError(null);
    setStatus(null);
    try {
      const response = await scraperApi.run(sources);
      const jobId = response.data.id;
      setStatus(response.data);

      // Poll for status
      pollRef.current = setInterval(async () => {
        try {
          const statusRes = await scraperApi.status(jobId);
          setStatus(statusRes.data);

          if (statusRes.data.status === 'completed' || statusRes.data.status === 'failed') {
            clearInterval(pollRef.current);
            pollRef.current = null;
            setScraping(false);
            if (statusRes.data.status === 'completed' && onComplete) {
              onComplete();
            }
            if (statusRes.data.status === 'failed') {
              setError(statusRes.data.error_message || 'Scrape failed');
            }
          }
        } catch (err) {
          clearInterval(pollRef.current);
          pollRef.current = null;
          setScraping(false);
          setError('Failed to check scrape status');
        }
      }, 2000);
    } catch (err) {
      setScraping(false);
      setError(err.response?.data?.detail || 'Failed to start scrape');
    }
  }, [onComplete]);

  const addByUrl = useCallback(async (url) => {
    setError(null);
    try {
      const response = await scraperApi.addByUrl(url);
      if (onComplete) onComplete();
      return response.data;
    } catch (err) {
      const message = err.response?.data?.detail || 'Failed to add card from URL';
      setError(message);
      throw new Error(message);
    }
  }, [onComplete]);

  return {
    scraping,
    status,
    error,
    startScrape,
    addByUrl,
  };
}
